<!-- 模块自定义表单渲染 -->
<template>
    <a-form-model ref="form" :model="form" :rules="rules" :class="{ 'sd-page-form': true, 'form-no-edit': !isEdit, customForm: true }">
        <slot name="formTop"></slot>
        <template v-for="(item, index) in fieldList">
            <div :key="index">
                <FormItemSelect
                    v-if="item.fieldFormType === 'select' && selectFieldConfigs[item.fieldCode]"
                    :value.sync="form[item.fieldCode]"
                    :copyValue="form[`encrypt${item.fieldCode}`]"
                    :field="item"
                    :filterType="filterType"
                    :isEdit="isEdit"
                    :selectFieldConfig="selectFieldConfigs[item.fieldCode]"
                    @validateField="validateField" />
                <form-item
                    v-else
                    :ref="`${item.fieldCode}`"
                    :value.sync="form[item.fieldCode]"
                    :copyValue="form[`encrypt${item.fieldCode}`]"
                    :field="item"
                    :filterType="filterType"
                    :isEdit="isEdit"
                    :isEditFrozen="isEditFrozen"
                    :customerId="customerId"
                    :formType="formType"
                    @update:value="updateValue"
                    @validateField="validateField"
                    @encryptValidateField="encryptValidateField"
                    @changeFieldCode="changeFieldCode"
                    :isPresetEncrypt="presetEncryptFiles.includes(item.fieldCode) || crmPresetEncryptFiles.includes(item.fieldCode)"
                    @onOutBound="$emit('onOutBound')" />
            </div>
        </template>
        <slot name="formRowBottom"></slot>
        <slot name="formBottom"></slot>
    </a-form-model>
</template>

<script>
import FormItem from "@/components/DynamicComponents/DynamicForm/components/FormItem";
import FormItemSelect from "@/components/DynamicComponents/DynamicForm/components/FormItemSelect";
import validate from "@/utils/CustomValidate";
import { ifCompareObject } from "@/utils/index";
import { queryAdvertisingSpaceByChannel } from "@/api/detail";

export default {
    name: "DynamicForm",
    components: {
        FormItem,
        FormItemSelect,
    },
    props: {
        // 学员Id
        customerId: {
            type: String,
            // required: true,
            default: "",
        },
        // 表单
        form: {
            type: Object,
            required: true,
        },
        // 字段列表
        fieldList: {
            type: Array,
            required: true,
        },
        // 过滤器类型
        filterType: {
            type: Number,
            required: true,
            /**
             * 过滤器类型
             * 0：学员
             * 2：订单
             * 3：订单课程
             * 4：支付明细
             * 5：赠送课程
             * 6: 退费单
             * 7：退费明细
             * 8: 报考
             * 9: 订金退费单
             * 10：订金退费单明细
             */
            validator(value) {
                return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(value);
            },
        },
        // 是否切换为编辑
        isEdit: {
            type: Boolean,
            default: false,
        },
        // 需要换行字符的最小长度
        warpLength: {
            type: Number,
            default: 9,
        },
        // 自定义校验规则
        customRules: {
            type: Object,
            default: () => {},
        },
        // 表单是否在编辑的时候加密字段
        isEditFrozen: {
            type: Boolean,
            default: false,
        },
        formType: {
            type: String,
            default: "",
        },
        // 是否使用选择字段关联规则
        isFieldCascadeRule: {
            type: Boolean,
            default: false,
        },
        // 关联规则
        cascadeFieldConfigList: {
            type: Array,
            default: () => [],
        },
        crmCustomerModel: {
            type: Object,
            default: () => {},
            required: false,
        },
    },
    data() {
        return {
            // 用于change交互校验效果
            changeFormType: ["select", "checkbox", "radio", "date", "time", "user", "depart", "textarea", "province", "city", "region", "cascade"],
            selectFieldConfigs: {},
            requireOtherConfig: [],
            presetEncryptFiles: [], //预设加密字段列表
            changeFiles: [], //已修改的加密字段列表
            crmPresetEncryptFiles: [], //crm预置加密字段
            crmChangeFiles: []
        };
    },
    mounted() {
        this.initRequired(); //初始化不可修改必填项
        this.isFieldCascadeRule && this.setSelectConfig();
    },
    computed: {
        rules() {
            let rules = {};

            if(this.crmCustomerModel){
                this.crmPresetEncryptFiles = []
                // Object.keys(this.form).forEach((key) => {
                //     if (key.includes('presetEncrypt')) {
                //     let fieldCode = key.replace('presetEncrypt', '') // 移除'encrypt'前缀以获取原字段名
                //     this.crmPresetEncryptFiles.push(fieldCode)
                //     }
                // })

                this.fieldList.forEach((item) => {
                    // console.log("=========== item1 ==========", item);

                    const ruleOptions = JSON.parse(item.commonProperties).rules;

                    // console.log("=========== item2 ==========", ruleOptions, item.fieldName);
                    const fieldRules = [];
                    if (item.isPresetEncrypted==1) {
                        this.crmPresetEncryptFiles.push(item.fieldCode) 
                    }

                    // ruleOptions = ruleOptions || {};

                    ruleOptions.forEach((option) => {
                        if (typeof option === "string") {
                            if (this.crmPresetEncryptFiles.includes(item.fieldCode) && !this.crmChangeFiles.includes(item.fieldCode)) {
                                // 预置加密字段还未改值时先不启用规则
                            } else {
                                fieldRules.push({
                                    label: item.fieldName,
                                    validator: validate[option],
                                    trigger: this.changeFormType.includes(item.fieldFormType) ? "change" : "blur",
                                });
                            }
                        }
                    });

                    // 字段自定义校验
                    // ruleOptions.forEach((option) => {
                    //   if (typeof option === "string") {
                    //     fieldRules.push({
                    //       label: item.fieldName,
                    //       validator: validate[option],
                    //       trigger: this.changeFormType.includes(item.fieldFormType)
                    //         ? "change"
                    //         : "blur",
                    //     });
                    //   }
                    // });
                    //其它配置关联必填
                    this.requireOtherConfig.forEach((v) => {
                        v.fieldValue.forEach((valueItem) => {
                            if (item.fieldCode === valueItem.fieldCode) {
                                fieldRules.unshift({
                                    required: true,
                                    message: `${valueItem.fieldName}不能为空`,
                                    trigger: this.changeFormType.includes(valueItem.fieldFormType) ? "change" : "blur",
                                });
                            }
                        });
                    });
                    // 必填校验
                    if (Number(item.isRequired)) {
                        fieldRules.unshift({
                            required: true,
                            message: `${item.fieldName}不能为空`,
                            trigger: this.changeFormType.includes(item.fieldFormType) ? "change" : "blur",
                        });
                    }
                    rules[item.fieldCode] = fieldRules;
                    console.log("什么鬼啊", item.fieldCode, fieldRules);
                });
                console.log("🔍 ~ rules ~ src/components/DynamicComponents/DynamicForm/index.vue:218 ~ rules:", rules);

            }else{
                this.presetEncryptFiles = []
                this.fieldList.forEach((item) => {
                    console.log("=========== item1 ==========", item);

                    const ruleOptions = JSON.parse(item.commonProperties).rules;

                    console.log("=========== item2 ==========", ruleOptions, item.fieldName);
                    const fieldRules = [];
                    if (item.isPresetEncrypted==1) {
                        this.presetEncryptFiles.push(item.fieldCode) 
                    }
                    // ruleOptions = ruleOptions || {};

                    ruleOptions.forEach((option) => {
                        if (typeof option === "string") {
                            const isPresetEncryptField = this.presetEncryptFiles.includes(item.fieldCode)
                            const hasChanged = this.changeFiles.includes(item.fieldCode)
                            // const originalValue = this.orgFormInfo?.[item.fieldCode]
                            // const isEmptyOriginal = !originalValue && originalValue !== 0
                if (isPresetEncryptField && !hasChanged ) {
                    //预置加密字段还未改值时先不启用规则（但原本为空的除外）
                    console.log(344,'预置加密字段还未改值时先不启用规则');
                }else{
                        fieldRules.push({
                                label: item.fieldName,
                                validator: validate[option],
                                trigger: this.changeFormType.includes(item.fieldFormType) ? "change" : "blur",
                            });
                }
                            
                        }
                    });

                    // 字段自定义校验
                    // ruleOptions.forEach((option) => {
                    //   if (typeof option === "string") {
                    //     fieldRules.push({
                    //       label: item.fieldName,
                    //       validator: validate[option],
                    //       trigger: this.changeFormType.includes(item.fieldFormType)
                    //         ? "change"
                    //         : "blur",
                    //     });
                    //   }
                    // });
                    //其它配置关联必填
                    this.requireOtherConfig.forEach((v) => {
                        v.fieldValue.forEach((valueItem) => {
                            if (item.fieldCode === valueItem.fieldCode) {
                                fieldRules.unshift({
                                    required: true,
                                    message: `${valueItem.fieldName}不能为空`,
                                    trigger: this.changeFormType.includes(valueItem.fieldFormType) ? "change" : "blur",
                                });
                            }
                        });
                    });
                    // 必填校验
                    if (Number(item.isRequired)) {
                        fieldRules.unshift({
                            required: true,
                            message: `${item.fieldName}不能为空`,
                            trigger: this.changeFormType.includes(item.fieldFormType) ? "change" : "blur",
                        });
                    }
                    rules[item.fieldCode] = fieldRules;
                });
            }
            rules = Object.assign(rules, this.customRules);
            //   console.log("rules ====>", rules);
            // 非中国大陆学员不校验身份证是
            if (this.crmCustomerModel && this.crmCustomerModel.customerDomiciliaryRegisterType == 2) {
                console.log(328, "身份证不校验");
                rules["id_card"] = [];
            }
            
            return rules;
        },
        computedForm() {
            // console.log(197, this.form, JSON.parse(JSON.stringify(this.form)));
            return JSON.parse(JSON.stringify(this.form));
            // try {
            //     // 安全解析
            //     return JSON.parse(JSON.stringify(this.form));
            // } catch (error) {
            //     console.error("JSON 解析失败:", this.form);
            //     return {};
            // }
            // return this.form;
        },
    },
    watch: {
        computedForm: {
            handler(newValue, oldValue) {
                console.log("--newValue", newValue, "oldValue", oldValue);
                this.isFieldCascadeRule && this.setSelectConfig();
                // 改变值的字段
                let changeFiles = ifCompareObject(newValue, oldValue);
                console.log("-changeFiles-", changeFiles);
                // this.cascadeFieldConfigList.forEach((item) => {
                //     let cascadeList = JSON.parse(item.cascadeJson);
                //     if (cascadeList && cascadeList.length) {
                //         cascadeList.forEach((v) => {
                //             v.fieldValue = "";
                //             if (v.parentField === changeFiles) {
                //                 this.form[v.field] = "";
                //             }
                //         });
                //     }
                // });
                //其它配置关联必填
                this.fieldList.forEach((item) => {
                    if (item.fieldCode === changeFiles) {
                        const optionsData = JSON.parse(item.options);
                        let childValue = "";
                        // debugger;
                        if (item.fieldFormType != "checkbox") {
                            try {
                                childValue = JSON.parse(newValue[changeFiles]);
                                childValue = childValue[childValue.length - 1];
                            } catch (e) {
                                childValue = newValue[changeFiles];
                            }
                        }
                        let arr = [];
                        let checkData = {
                            fieldCode: "",
                            fieldValue: arr,
                        };
                        if (optionsData && optionsData.length > 0) {
                            optionsData.forEach((v) => {
                                // 级联选项
                                if (v.children) {
                                    // 遍历第一级子项
                                    if (v.value === childValue.value) {
                                        arr = v.relevanceIds || [];
                                        checkData = {
                                            fieldCode: item.fieldCode,
                                            fieldValue: arr,
                                        };
                                        let existingIndex = this.requireOtherConfig.findIndex((f) => f.fieldCode === item.fieldCode);
                                        if (existingIndex !== -1) {
                                            this.requireOtherConfig[existingIndex].fieldValue = arr;
                                        } else {
                                            this.requireOtherConfig.push(checkData);
                                        }
                                    } else {
                                        // 遍历更深层级的子项
                                        this.handleChildRelevanceIds(v.children, childValue, item);
                                    }
                                }
                                // 正常选项
                                if (v.value === newValue[changeFiles]) {
                                    let arr = v.relevanceIds || [];
                                    const checkData = {
                                        fieldCode: item.fieldCode,
                                        fieldValue: arr,
                                    };
                                    console.log("checkData", checkData);
                                    let existingIndex = this.requireOtherConfig.findIndex((f) => f.fieldCode === item.fieldCode);
                                    if (existingIndex !== -1) {
                                        this.requireOtherConfig[existingIndex].fieldValue = arr;
                                    } else {
                                        this.requireOtherConfig.push(checkData);
                                    }
                                }
                                //复选框
                                if (item.fieldFormType === "checkbox") {
                                    let str = newValue[changeFiles];
                                    let checkboxVal = str.split(",");
                                    checkboxVal = checkboxVal.map(Number);
                                    if (str === "") {
                                        checkboxVal = [];
                                        arr = [];
                                    }
                                    if (checkboxVal.includes(v.value)) {
                                        if (v.relevanceIds) {
                                            arr.push(...v.relevanceIds);
                                        }
                                    }
                                    const checkData = {
                                        fieldCode: item.fieldCode,
                                        fieldValue: arr,
                                    };
                                    let existingIndex = this.requireOtherConfig.findIndex((f) => f.fieldCode === item.fieldCode);
                                    if (existingIndex !== -1) {
                                        this.requireOtherConfig[existingIndex].fieldValue = arr;
                                    } else {
                                        this.requireOtherConfig.push(checkData);
                                    }
                                }
                            });
                        }
                    }
                });
                //根据渠道选项值获取广告位
                if (changeFiles === "channel") {
                    let channelValue = newValue["channel"];
                    queryAdvertisingSpaceByChannel({ channel: channelValue }).then((res) => {
                        console.log("res", res);
                        let adOptions = res.result;
                        if (res.code === 200) {
                            this.fieldList.forEach((item) => {
                                if (item.fieldCode === "advertising_space") {
                                    this.fieldList.splice(this.fieldList.indexOf(item), 1, adOptions);
                                    console.log("this.fieldList", this.fieldList);
                                }
                            });
                        }
                    });
                }
                // 加密字段 判断是否存在加密字段 encrypt+changeFiles
                const encryptField = `encrypt${changeFiles}`;
                if (this.form[encryptField]) {
                    delete this.form[encryptField];
                }
            },
            deep: true,
        },
    },
    methods: {
        initRequired() {
            this.fieldList.forEach((item) => {
                if (item.fieldFormType === "select" || item.fieldFormType === "radio" || item.fieldFormType === "cascade") {
                    // if (item.isModify === 0) {
                    for (let key in this.form) {
                        if (item.fieldCode === key && this.form[key] != "") {
                            let optionsData = JSON.parse(item.options);
                            optionsData.forEach((opItem) => {
                                if (opItem.children) {
                                    let childVal = JSON.parse(this.form[item.fieldCode]);
                                    childVal = childVal[childVal.length - 1];
                                    if (childVal) {
                                        if (opItem.value == childVal.value) {
                                            if (opItem.relevanceIds) {
                                                let checkData = {
                                                    fieldCode: item.fieldCode,
                                                    fieldValue: opItem.relevanceIds,
                                                };
                                                this.requireOtherConfig.push(checkData);
                                            }
                                        } else {
                                            // 遍历更深层级的子项
                                            this.loopChild(opItem.children, childVal, item);
                                        }
                                    }
                                }
                                if (opItem.value == this.form[item.fieldCode]) {
                                    if (opItem.relevanceIds) {
                                        let checkData = {
                                            fieldCode: item.fieldCode,
                                            fieldValue: opItem.relevanceIds,
                                        };
                                        this.requireOtherConfig.push(checkData);
                                    }
                                }
                            });
                        }
                    }
                    // }
                }
            });
        },
        loopChild(opItem, childVal, item) {
            opItem.forEach((child) => {
                if (child.value == childVal.value) {
                    if (child.relevanceIds) {
                        let checkData = {
                            fieldCode: item.fieldCode,
                            fieldValue: child.relevanceIds,
                        };
                        this.requireOtherConfig.push(checkData);
                    }
                } else {
                    // 遍历更深层级的子项
                    this.loopChild(child.children, childVal, item);
                }
            });
        },
          changeFieldCode(fieldCode) {
            if(this.crmCustomerModel){
                if (!this.crmChangeFiles.includes(fieldCode)) {
                    this.crmChangeFiles.push(fieldCode)
                    this.crmChangeFiles = JSON.parse(JSON.stringify(this.crmChangeFiles))
                }
                console.log('crmChangeFilesCode', fieldCode, this.crmChangeFiles)
            }else{
                if (!this.changeFiles.includes(fieldCode)) {
                    this.changeFiles.push(fieldCode)
                }
                console.log('changeFieldCode', fieldCode, this.changeFiles)
            }
            
        },
           // 获取预置加密字段的值
         getpresetEncryptField() {
            if(this.crmCustomerModel){

                let changeFields = {}
                this.crmPresetEncryptFiles.forEach((item) => {
                if (this.crmChangeFiles.includes(item)) {
                    changeFields[item] = this.form[item]
                }
                })
                console.log('crm变更字段', changeFields, this.crmChangeFiles, this.form)

                return changeFields
            }else{
                let changeFields = {}
                this.presetEncryptFiles.forEach((item) => {
                if (this.changeFiles.includes(item)) {
                    changeFields[item] = this.form[item]
                }
                })
                console.log('网校变更字段', changeFields)

                return changeFields
            }
                
            },
        validate(callback) {
            this.$refs.form.validate((valid) => {
                callback(Boolean(valid));
            });
        },
        validatePromise() {
            return this.$refs.form.validate();
        },
        validateField(prop) {
            this.$refs.form.validateField(prop);
        },
        updateValue(e) {
            // console.log(398, e, this.form);
            this.$emit("update:value", this.form);
        },
        encryptValidateField(prop) {
            this.$refs.form.validateField(prop, (es) => {
                // 校验正确
                if (!es) {
                    this.$refs[prop][0].validatePromise(true);
                }
                // 校验错误
                else {
                    this.$refs[prop][0].validatePromise(false);
                }
            });
        },

        // 移除校验
        resetFields() {
            this.$refs.form.resetFields();
        },
        // 根据 选择字段规则 设置选择字段配置
        setSelectConfig() {
            if (this.isFieldCascadeRule) {
                const selectFieldConfigs = {};
                let cascadeFieldConfigList = [];
                this.cascadeFieldConfigList.forEach((item) => {
                    let cascadeList = JSON.parse(item.cascadeJson);
                    if (cascadeList.length) {
                        const fieldCodes = [];
                        cascadeList.forEach((child) => {
                            fieldCodes.push(child.field);
                        });
                        cascadeList.forEach((child) => {
                            child.fieldCodeStr = fieldCodes.join("_");
                        });
                        cascadeFieldConfigList = cascadeFieldConfigList.concat(cascadeList);
                    }
                });
                cascadeFieldConfigList.forEach((item) => {
                    if (!selectFieldConfigs[item.field] && item.parentField !== "no_parent_field") {
                        selectFieldConfigs[item.field] = {
                            parentField: item.parentField,
                            // disabled: this.setFieldDisable(item, cascadeFieldConfigList, this.form),
                            placeholder: this.setFieldPlaceholder(item, cascadeFieldConfigList, this.form),
                            optionalValues: this.setFieldOptionalValues(item, cascadeFieldConfigList, this.form),
                        };
                    }
                });
                this.selectFieldConfigs = selectFieldConfigs;
            } else {
                this.selectFieldConfigs = {};
            }
        },
        // 设置字段 placeholder
        setFieldPlaceholder(fieldConfig, configList, form) {
            // if (fieldConfig.parentField === 'no_parent_field') {
            //     return '请选择'
            // }
            // else {}
            const fieldList = configList.filter((item) => item.field === fieldConfig.field && item.parentField !== "no_parent_field");
            const fieldNames = [];
            fieldList.forEach((item) => {
                const parentFieldList = configList.filter((item) => item.field === fieldConfig.parentField && item.fieldCodeStr === fieldConfig.fieldCodeStr);

                !form[item.parentField] && fieldNames.push(parentFieldList[0].fieldName);
                if (item.parentField == "enterprise_add_mode" && form[item.parentField] == 0) {
                    fieldNames.splice(0, fieldNames.length);
                }
            });
            return fieldNames.length ? `请先选择${fieldNames.join("、")}` : "";
        },
        // 设置字段可选项
        setFieldOptionalValues(fieldConfig, configList, form) {
            const parentFieldList = configList.filter((item) => item.field === fieldConfig.parentField && item.fieldCodeStr === fieldConfig.fieldCodeStr);
            let optionalValues = [];
            parentFieldList.forEach((item) => {
                let addModeVal = false;
                if (item.field == "enterprise_add_mode" && form[item.field] == 0) {
                    addModeVal = true;
                }
                // 父级字段已选值
                if (form[item.field] || item.fieldValue || addModeVal) {
                    let options;
                    if (form[item.field] || addModeVal) {
                        options = item.options.filter((child) => child.value === form[item.field]);
                    } else {
                        options = item.options.filter((child) => child.value === Number(item.fieldValue));
                    }
                    if (options.length) {
                        optionalValues = optionalValues.concat(options[0].optionalValues);
                    }
                } else {
                    optionalValues = this.fieldList
                        .filter((v) => v.fieldName === fieldConfig.fieldName)
                        .map((v) => JSON.parse(v.commonProperties).options.options.map((i) => i.value))
                        .flat();
                }
            });
            // console.log('-optionalValues-', optionalValues)
            return optionalValues;
        },
        // 递归处理子项的关联必填项
        handleChildRelevanceIds(children, childValue, fieldItem) {
            children.forEach((child) => {
                if (child.value === childValue.value) {
                    let arr = child.relevanceIds || [];
                    let checkData = {
                        fieldCode: fieldItem.fieldCode,
                        fieldValue: arr,
                    };
                    let existingIndex = this.requireOtherConfig.findIndex((f) => f.fieldCode === fieldItem.fieldCode);
                    if (existingIndex !== -1) {
                        this.requireOtherConfig[existingIndex].fieldValue = arr;
                    } else {
                        this.requireOtherConfig.push(checkData);
                    }
                } else {
                    // 遍历更深层级的子项
                    this.handleChildRelevanceIds(child.children, childValue, fieldItem);
                }
            });
        },
    },
};
</script>

<style lang="less">
.customForm {
    .ant-form-item {
        display: flex;
        margin: 4px 0 0 0;

        .ant-form-item-label {
            display: flex;
            flex-direction: row;
            // align-items: center;
            line-height: 35px;
            justify-content: flex-end;
            min-width: 120px;
            width: 20%;
            flex-shrink: 0;
            color: rgba(0, 0, 0, 0.85);
            text-align: right;
            margin-right: 10px;
            padding: 0;

            label {
                white-space: nowrap;
                text-overflow: ellipsis;
                display: inline-block;
                overflow: hidden;
                width: 100%;
            }
        }

        .ant-form-item-control-wrapper {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-shrink: 1;
            white-space: nowrap;
            color: rgba(0, 0, 0, 0.65);
        }
    }
}
</style>
